// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2-dQU","title":"FrontImage_title__1yVhM"};